"use client";

import { c as _c } from "react/compiler-runtime";
import { DELEGATION_ABI } from "@/abis/abis";
import { useAuth } from "@/components/auth/Auth";
import { PRIMARY_ADDRESS_USE_CASE } from "@/components/delegation/delegation-constants";
import EtherscanIcon from "@/components/user/utils/icons/EtherscanIcon";
import OpenseaIcon from "@/components/user/utils/icons/OpenseaIcon";
import CopyIcon from "@/components/utils/icons/CopyIcon";
import { DELEGATION_ALL_ADDRESS, DELEGATION_CONTRACT, NEVER_DATE } from "@/constants/constants";
import type { ApiWallet } from "@/generated/models/ApiWallet";
import { getTransactionLink } from "@/helpers/Helpers";
import { TOOLTIP_STYLES } from "@/helpers/tooltip.helpers";
import { useEffect, useState } from "react";
import { Tooltip } from "react-tooltip";
import { useCopyToClipboard } from "react-use";
import { useWaitForTransactionReceipt, useWriteContract } from "wagmi";
import UserPageIdentityStatementsConsolidatedAddressesItemPrimary from "./UserPageIdentityStatementsConsolidatedAddressesItemPrimary";
export default function UserPageIdentityStatementsConsolidatedAddressesItem(t0) {
  const $ = _c(93);
  const {
    address,
    primaryAddress,
    canEdit
  } = t0;
  const {
    setToast
  } = useAuth();
  let t1;
  if ($[0] !== address.wallet) {
    t1 = e => {
      e.stopPropagation();
      window.open(`https://opensea.io/${address.wallet}`, "_blank");
    };
    $[0] = address.wallet;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const goToOpensea = t1;
  let t2;
  if ($[2] !== address.wallet) {
    t2 = () => {
      window.open(`https://etherscan.io/address/${address.wallet}`, "_blank");
    };
    $[2] = address.wallet;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const goToEtherscan = t2;
  let t3;
  if ($[4] !== address.wallet) {
    t3 = address.wallet.toLowerCase();
    $[4] = address.wallet;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== primaryAddress) {
    t4 = primaryAddress?.toLowerCase();
    $[6] = primaryAddress;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const isPrimary = t3 === t4;
  let t5;
  if ($[8] !== address.wallet) {
    t5 = address.wallet.slice(0, 6);
    $[8] = address.wallet;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const [title, setTitle] = useState(t5);
  const [, copyToClipboard] = useCopyToClipboard();
  let t6;
  if ($[10] !== address.wallet || $[11] !== copyToClipboard) {
    t6 = () => {
      copyToClipboard(address.wallet);
      setTitle("Copied!");
      setTimeout(() => {
        setTitle(address.wallet.slice(0, 6));
      }, 1000);
    };
    $[10] = address.wallet;
    $[11] = copyToClipboard;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  const handleCopy = t6;
  const [isTouchScreen, setIsTouchScreen] = useState(false);
  let t7;
  let t8;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = () => {
      setIsTouchScreen(window.matchMedia("(pointer: coarse)").matches);
    };
    t8 = [];
    $[13] = t7;
    $[14] = t8;
  } else {
    t7 = $[13];
    t8 = $[14];
  }
  useEffect(t7, t8);
  const [assigningPrimary, setAssigningPrimary] = useState(false);
  const [statusMessage, setStatusMessage] = useState();
  const writeDelegation = useWriteContract();
  let t9;
  if ($[15] !== writeDelegation.data) {
    t9 = {
      confirmations: 1,
      hash: writeDelegation.data
    };
    $[15] = writeDelegation.data;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  const waitWriteDelegation = useWaitForTransactionReceipt(t9);
  let t10;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = function getError(e_0) {
      return e_0.message.split("Request Arguments")[0];
    };
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  const getError = t10;
  let t11;
  if ($[18] !== setToast || $[19] !== waitWriteDelegation.data || $[20] !== waitWriteDelegation.error || $[21] !== waitWriteDelegation.isLoading || $[22] !== writeDelegation.data || $[23] !== writeDelegation.isPending) {
    t11 = () => {
      if (writeDelegation.isPending) {
        setStatusMessage("Confirm in your wallet...");
      } else {
        if (writeDelegation.data) {
          const trxLink = <>{writeDelegation.data && <a href={getTransactionLink(DELEGATION_CONTRACT.chain_id, writeDelegation.data)} target="_blank" rel="noopener noreferrer" className="tw-text-primary-400 tw-underline">View Transaction</a>}</>;
          if (waitWriteDelegation.isLoading) {
            setStatusMessage(<>Waiting for confirmation... {trxLink}</>);
          } else {
            if (waitWriteDelegation.data) {
              setStatusMessage(<>Confirmed! Check back in a few minutes to see the change. {trxLink}</>);
              setToast({
                type: "success",
                message: "Primary address set successfully"
              });
            } else {
              if (waitWriteDelegation.error) {
                setStatusMessage(<>Error: {getError(waitWriteDelegation.error)} {trxLink}</>);
                setToast({
                  type: "error",
                  message: `Error setting primary address: ${getError(waitWriteDelegation.error)}`
                });
              }
            }
          }
        } else {
          setStatusMessage(undefined);
        }
      }
    };
    $[18] = setToast;
    $[19] = waitWriteDelegation.data;
    $[20] = waitWriteDelegation.error;
    $[21] = waitWriteDelegation.isLoading;
    $[22] = writeDelegation.data;
    $[23] = writeDelegation.isPending;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== waitWriteDelegation.status || $[26] !== writeDelegation.status) {
    t12 = [writeDelegation.status, waitWriteDelegation.status];
    $[25] = waitWriteDelegation.status;
    $[26] = writeDelegation.status;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  useEffect(t11, t12);
  let t13;
  if ($[28] !== address.wallet || $[29] !== writeDelegation) {
    t13 = async () => {
      setAssigningPrimary(true);
      writeDelegation.writeContract({
        address: DELEGATION_CONTRACT.contract,
        abi: DELEGATION_ABI,
        chainId: DELEGATION_CONTRACT.chain_id,
        functionName: "registerDelegationAddress",
        args: [DELEGATION_ALL_ADDRESS, address.wallet, NEVER_DATE, PRIMARY_ADDRESS_USE_CASE.use_case, true, 0]
      });
    };
    $[28] = address.wallet;
    $[29] = writeDelegation;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  const assignPrimary = t13;
  let t14;
  if ($[31] !== title) {
    t14 = title === "Copied!" ? <span className="tw-text-primary-400">{title}</span> : title;
    $[31] = title;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  let t15;
  if ($[33] !== t14) {
    t15 = <span className="tw-text-xs tw-font-normal tw-text-iron-400 tw-font-mono">{t14}</span>;
    $[33] = t14;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  let t16;
  if ($[35] !== assignPrimary || $[36] !== assigningPrimary || $[37] !== canEdit || $[38] !== isPrimary) {
    t16 = <UserPageIdentityStatementsConsolidatedAddressesItemPrimary isPrimary={isPrimary} canEdit={canEdit} assignPrimary={assignPrimary} isAssigningPrimary={assigningPrimary} />;
    $[35] = assignPrimary;
    $[36] = assigningPrimary;
    $[37] = canEdit;
    $[38] = isPrimary;
    $[39] = t16;
  } else {
    t16 = $[39];
  }
  let t17;
  if ($[40] !== t15 || $[41] !== t16) {
    t17 = <div className="tw-flex tw-items-center tw-gap-2 tw-mb-0.5">{t15}{t16}</div>;
    $[40] = t15;
    $[41] = t16;
    $[42] = t17;
  } else {
    t17 = $[42];
  }
  let t18;
  if ($[43] !== address.display) {
    t18 = address.display && <div className="tw-text-xs tw-font-semibold tw-font-mono tw-text-iron-200 tw-truncate tw-max-w-[130px]">{address.display}</div>;
    $[43] = address.display;
    $[44] = t18;
  } else {
    t18 = $[44];
  }
  let t19;
  if ($[45] !== t17 || $[46] !== t18) {
    t19 = <div className="tw-flex-1 tw-min-w-0">{t17}{t18}</div>;
    $[45] = t17;
    $[46] = t18;
    $[47] = t19;
  } else {
    t19 = $[47];
  }
  const t20 = `etherscan-tooltip-${address.wallet}`;
  let t21;
  if ($[48] !== isTouchScreen) {
    t21 = !isTouchScreen ? {
      "data-tooltip-content": "Etherscan"
    } : null;
    $[48] = isTouchScreen;
    $[49] = t21;
  } else {
    t21 = $[49];
  }
  let t22;
  if ($[50] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <div className="tw-h-5 tw-w-5 lg:tw-h-4 lg:tw-w-4 tw-flex-shrink-0 tw-flex tw-items-center tw-justify-center"><EtherscanIcon /></div>;
    $[50] = t22;
  } else {
    t22 = $[50];
  }
  let t23;
  if ($[51] !== goToEtherscan || $[52] !== t20 || $[53] !== t21) {
    t23 = <button onClick={goToEtherscan} aria-label="Go to Etherscan" className="tw-border-none tw-bg-transparent tw-p-1.5 lg:tw-p-0 tw-cursor-pointer tw-text-iron-500 hover:tw-text-iron-200 tw-transition tw-duration-300 tw-ease-out" data-tooltip-id={t20} {...t21}>{t22}</button>;
    $[51] = goToEtherscan;
    $[52] = t20;
    $[53] = t21;
    $[54] = t23;
  } else {
    t23 = $[54];
  }
  let t24;
  if ($[55] !== address.wallet || $[56] !== isTouchScreen) {
    t24 = !isTouchScreen && <Tooltip id={`etherscan-tooltip-${address.wallet}`} place="top" positionStrategy="fixed" offset={8} opacity={1} style={TOOLTIP_STYLES} />;
    $[55] = address.wallet;
    $[56] = isTouchScreen;
    $[57] = t24;
  } else {
    t24 = $[57];
  }
  const t25 = `opensea-tooltip-${address.wallet}`;
  let t26;
  if ($[58] !== isTouchScreen) {
    t26 = isTouchScreen ? null : {
      "data-tooltip-content": "Opensea"
    };
    $[58] = isTouchScreen;
    $[59] = t26;
  } else {
    t26 = $[59];
  }
  let t27;
  if ($[60] === Symbol.for("react.memo_cache_sentinel")) {
    t27 = <div className="tw-h-5 tw-w-5 lg:tw-h-4 lg:tw-w-4 tw-flex-shrink-0 tw-flex tw-items-center tw-justify-center"><OpenseaIcon /></div>;
    $[60] = t27;
  } else {
    t27 = $[60];
  }
  let t28;
  if ($[61] !== goToOpensea || $[62] !== t25 || $[63] !== t26) {
    t28 = <button onClick={goToOpensea} aria-label="Go to Opensea" className="tw-border-none tw-bg-transparent tw-p-1.5 lg:tw-p-0 tw-cursor-pointer tw-text-iron-500 hover:tw-text-iron-200 tw-transition tw-duration-300 tw-ease-out" data-tooltip-id={t25} {...t26}>{t27}</button>;
    $[61] = goToOpensea;
    $[62] = t25;
    $[63] = t26;
    $[64] = t28;
  } else {
    t28 = $[64];
  }
  let t29;
  if ($[65] !== address.wallet || $[66] !== isTouchScreen) {
    t29 = !isTouchScreen && <Tooltip id={`opensea-tooltip-${address.wallet}`} place="top" positionStrategy="fixed" offset={8} opacity={1} style={TOOLTIP_STYLES} />;
    $[65] = address.wallet;
    $[66] = isTouchScreen;
    $[67] = t29;
  } else {
    t29 = $[67];
  }
  const t30 = `copy-tooltip-${address.wallet}`;
  let t31;
  if ($[68] !== isTouchScreen) {
    t31 = !isTouchScreen ? {
      "data-tooltip-content": "Copy"
    } : null;
    $[68] = isTouchScreen;
    $[69] = t31;
  } else {
    t31 = $[69];
  }
  let t32;
  if ($[70] === Symbol.for("react.memo_cache_sentinel")) {
    t32 = <div className="tw-h-5 tw-w-5 lg:tw-h-4 lg:tw-w-4 tw-flex-shrink-0 tw-flex tw-items-center tw-justify-center [&>svg]:tw-w-full [&>svg]:tw-h-full"><CopyIcon /></div>;
    $[70] = t32;
  } else {
    t32 = $[70];
  }
  let t33;
  if ($[71] !== handleCopy || $[72] !== t30 || $[73] !== t31) {
    t33 = <button aria-label="Copy address" className="tw-cursor-pointer tw-border-0 tw-bg-transparent tw-p-1.5 lg:tw-p-0 tw-text-iron-600 tw-transition tw-duration-300 tw-ease-out hover:tw-text-iron-200 focus:tw-outline-none" onClick={handleCopy} data-tooltip-id={t30} {...t31}>{t32}</button>;
    $[71] = handleCopy;
    $[72] = t30;
    $[73] = t31;
    $[74] = t33;
  } else {
    t33 = $[74];
  }
  let t34;
  if ($[75] !== address.wallet || $[76] !== isTouchScreen) {
    t34 = !isTouchScreen && <Tooltip id={`copy-tooltip-${address.wallet}`} place="top" positionStrategy="fixed" offset={8} opacity={1} style={TOOLTIP_STYLES} />;
    $[75] = address.wallet;
    $[76] = isTouchScreen;
    $[77] = t34;
  } else {
    t34 = $[77];
  }
  let t35;
  if ($[78] !== t23 || $[79] !== t24 || $[80] !== t28 || $[81] !== t29 || $[82] !== t33 || $[83] !== t34) {
    t35 = <div className="tw-flex tw-items-center tw-gap-3 lg:tw-gap-2 tw-ml-auto tw-flex-shrink-0">{t23}{t24}{t28}{t29}{t33}{t34}</div>;
    $[78] = t23;
    $[79] = t24;
    $[80] = t28;
    $[81] = t29;
    $[82] = t33;
    $[83] = t34;
    $[84] = t35;
  } else {
    t35 = $[84];
  }
  let t36;
  if ($[85] !== t19 || $[86] !== t35) {
    t36 = <div className="tw-group tw-flex tw-items-center tw-justify-between tw-gap-x-3 tw-py-1">{t19}{t35}</div>;
    $[85] = t19;
    $[86] = t35;
    $[87] = t36;
  } else {
    t36 = $[87];
  }
  let t37;
  if ($[88] !== statusMessage) {
    t37 = statusMessage && <div className="tw-pt-2 tw-text-xs tw-font-medium tw-text-iron-200">{statusMessage}</div>;
    $[88] = statusMessage;
    $[89] = t37;
  } else {
    t37 = $[89];
  }
  let t38;
  if ($[90] !== t36 || $[91] !== t37) {
    t38 = <li>{t36}{t37}</li>;
    $[90] = t36;
    $[91] = t37;
    $[92] = t38;
  } else {
    t38 = $[92];
  }
  return t38;
}